import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import {
    getValidationRawTypes,
    selectValidationRawTypes,
    selectValidationRawTypesLoadingStatus,
} from 'features/validationRawTypes/validationRawTypesSlice';

export function useValidationRawTypes() {
    const dispatch = useDispatch();

    const loadingStatus = useSelector(selectValidationRawTypesLoadingStatus);
    const validationRawTypes = useSelector(selectValidationRawTypes);

    useEffect(() => {
        const fetchValidationRawTypes = async () => {
            dispatch(getValidationRawTypes());
        };
        if (loadingStatus == LoadingStatus.Idle) {
            fetchValidationRawTypes();
        }
    }, []);

    return { loadingStatus, validationRawTypes };
}
